// Supabase client — reads URL + anon key from CRA env vars at build time.
//
// To wire this up, create a .env.local at the repo root with:
//   REACT_APP_SUPABASE_URL=https://<project-ref>.supabase.co
//   REACT_APP_SUPABASE_ANON_KEY=<anon public key>
//
// CRA only inlines env vars prefixed with REACT_APP_. The anon key is meant
// to be public; restrict writes via Row Level Security in the database.
//
// If either var is missing the client is null, and callers fall back to the
// static seed data — so the site keeps working before Supabase is configured.
import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase =
  url && anonKey ? createClient(url, anonKey) : null;

export const isSupabaseConfigured = () => supabase !== null;
